import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getMessage = unaryRpc({
  name: "getMessage",
  input: z.object({ name: z.string().optional() }),
  output: z.object({ message: z.string(), timestamp: z.string() }),
});
